import { BadgeBox } from "./BadgeBox";
import { CheckCategory } from "../../../../../utils/enums";
import { CHECK_CATEGORIES } from "./CheckConstant";

export const CheckCategoryIcons = (category) => {
  if (!category) return null;

  let found = null;
  if (category.includes(CheckCategory?.PASS_WITH_EVIDENCE)) {
    found = CHECK_CATEGORIES.find((c) => c.key === "NA");
  } else if (category.includes(CheckCategory?.WORKFLOW_CHECK)) {
    found = CHECK_CATEGORIES.find((c) => c.key === "PA");
  } else {
    found = CHECK_CATEGORIES.find((c) => c.key === "FA");
  }

  return (
    <BadgeBox shortLabel={found?.shortLabel} fullLabel={found?.fullLabel} />
  );
};
